import React, { useState } from 'react';
import { useDispatch } from 'react-redux'

// history
import { useHistory } from "react-router-dom";

// apollo
import { useApolloClient } from '@apollo/react-hooks';

// query
import { LOGIN } from '../querys/user.query';


// redux functions
import { USER_CREATE, userCreate } from '../redux/duck/user-duck'

import '../scss/login.scss';

const LoginPage = () => {

    // dispatch
    const dispatch = useDispatch()

    const history = useHistory();

    const client = useApolloClient();

    const [error, setError] = useState(false);
    const [withOutUser, setWithOutUser] = useState(false);
    const [withOutPassword, setWithOutPassword] = useState(false);

    const clear = () => {
        document.getElementById('username').value = '';
        document.getElementById('password').value = '';
    }
    
    const login = async () => {
        const user = document.getElementById('username').value;
        const password = document.getElementById('password').value;
    
        if(!user) {
            setWithOutUser(true);
        }

        if(!password) {
            setWithOutPassword(true);
        }
    
        console.log('user', user);
        console.log('password', password);

        if( user && password ) {
            const variables = {
                name: user,
                password: password
            };

            try {
                console.log('result')
                const result =  await client.query({
                    query: LOGIN,
                    variables: variables,
                    fetchPolicy: 'no-cache'
                });
    
                const data = result.data.login;
    
                if (data) {
                    localStorage.setItem('token', data);
                    dispatch({ type: USER_CREATE });

                    dispatch(userCreate({
                        token: data
                    }));
                    history.push("/phone");
                } else {
                    setError(true);
                }
            } catch (error) {
                console.log(error)
                setError(true);
            }
        }
    };

    const onChange = () => {
        const user = document.getElementById('username').value;
        const password = document.getElementById('password').value;
    
        if(!user) {
            setWithOutUser(true);
        } else {
            setWithOutUser(false);
        }

        if(!password) {
            setWithOutPassword(true);
        } else {
            setWithOutPassword(false);
        }
    }

    return <div id="login">
        <div className="container">
            <div id="login-row" className="row justify-content-center align-items-center">
                <div id="login-column" className="col-md-6">
                    <div id="login-box" className="col-md-12">
                        <form id="login-form" className="form" action="" method="post">
                            <h3 className="text-center text-white">Login</h3>
                            <div className="form-group">
                                <label htmlFor="username" className="text-white">Usuario:</label>
                                <input type="text" name="username" id="username" className="form-control" onChange={onChange} />
                            </div>
                            {
                                withOutUser && 
                                <div>
                                    <small className="text-warning"> <strong>  Ingrese un usuario </strong>  </small>
                                </div>
                            }
                            <div className="form-group">
                                <label htmlFor="password" className="text-white">Contraseña:</label>
                                <input type="password" name="password" id="password" className="form-control"  onChange={onChange} />
                            </div>
                            {
                                withOutPassword &&
                                <div>
                                        <small className="text-warning"> <strong> Ingrese una contraseña </strong> </small>
                                </div>
                            }
                            <div>
                                <div className="row mt-3">
                                    <div className="col-auto">
                                        <button type="button" className="btn btn-primary" onClick={login}>Login</button>
                                    </div>
                                    <div className="col-auto">
                                        <button type="button" className="btn btn-danger" onClick={clear}>Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                        {
                            error && 
                            <div className="alert alert-warning text-center" role="alert">
                                <small className="text-warning"> <strong> Usuario o contraseña incorrecta </strong> </small>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
}

export default LoginPage;
